// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".like_user[data-v-37b73468] {\n  width: 9.573333rem !important;\n  height: 1.92rem;\n  border-bottom: 0.013333rem solid #E5E5E5;\n  padding: 0 !important;\n  position: relative;\n}\n.like_user[data-v-37b73468]:last-child {\n  border-bottom: none;\n}\n.user_left[data-v-37b73468] {\n  position: absolute;\n  left: 0;\n}\n.like_user .like_btns[data-v-37b73468] {\n  position: absolute;\n  right: 0.426667rem;\n}", ""]);
// Exports
module.exports = exports;
